<template lang="pug">
//- 适配H5预览
el-table.fileView(v-if="files.length > 0" :data="files" :show-header="false" max-height="200px")
  el-table-column(label="名称" v-slot="{row}")
    .labelList
      img(:src="className(row)")
      .title(@click="preview(row)") {{row.fileName}}
  el-table-column(label="操作"  width="45px" v-slot="{row}")
    i.el-icon-delete(title="删除" v-if="!noDelete" @click="deleteRow(row)")
  </template>

<script>
import { Dialog } from "vant";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import { viewAppFileMethods } from "@/CommonDP/pages/appView/utils";

export default {
  props: {
    files: { type: Array, default: () => [] },
    noDelete: { type: Boolean, default: false },
    uuid: { type: String, default: "" }
  },
  data() {
    return {};
  },
  computed: {
    flowInstanceId() {
      return getApprove(this.uuid)?.getMessage()?.flowInstanceId || "";
    }
  },
  methods: {
    className(row) {
      return tableRowIcon(row);
    },

    // 预览
    preview(row) {
      const data = {
        fileType: row.fileType,
        fileId: row.fileId,
        versionId: row.versionIds || row.fileVersion,
        flowInstanceId: this.flowInstanceId
      };
      viewAppFileMethods(row, data);
    },
    // 删除
    deleteRow(row) {
      Dialog.confirm({
        message: `您确定删除已经上传的${row.fileName}文件嘛`
      })
        .then(async () => {
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.fileView {
  border-top: 1px solid #ebeef5;
}
.labelList {
  width: 100%;
  height: 100%;
  padding-left: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 22px;
    height: 22px;
  }
  .title {
    margin-left: 5px;
    cursor: pointer;
    font-size: 14px;
  }
}
.el-icon-download {
  font-size: 16px;
  color: var(--theme-color);
  cursor: pointer;
}
.el-icon-delete {
  margin-left: 5px;
  font-size: 16px;
  color: #f54f45;
  cursor: pointer;
}
</style>
